import useAuthStore from '@/stores/auth'

class TokenService {
	private authStore = useAuthStore()

	getToken(): string | null {
		return this.authStore.accessToken
	}

	getIdToken(): string | null {
		return this.authStore.idToken
	}

	getMiddlewareToken(): string | null {
		if (this.authStore.user && this.authStore.user.middleware_token) {
			return this.authStore.user.middleware_token
		}

		return null
	}

	async refreshAuthToken() {
		try {
			const response = await fetch('/.auth/refresh', {
				method: 'POST'
			})

			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`)
			}

			const data = await response.json()
			return data
		} catch (error) {
			console.error('Error refreshing token:', error)
			throw error
		}
	}

	checkAuthToken(minutes = 10) {
		const accessTokenExpiry = this.authStore.accessTokenExpiry
		if (!accessTokenExpiry) return false

		const now = new Date()
		const expirationWindow = this.addMinutes(now, minutes)
		return expirationWindow.toDateString() < accessTokenExpiry
	}

	tokenHasExpired() {
		return !this.checkAuthToken(0)
	}

	addMinutes(date: Date, minutes: number) {
		return new Date(date.getTime() + minutes * 60000)
	}
}

export default TokenService
